var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"product-header container-fluid"},[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumbItemOverride || _vm.breadcrumbItems}}),_c('ProductLinkTabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }